import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { PageNames } from 'src/app/configs/page-names.enum';

import { SetIpRateLimitRuleRequest } from 'src/app/core/api/models';
import { ApiTokenService, EnumsService } from 'src/app/core/api/services';
import { JsonFormatterDirective } from 'src/app/core/directives/json-formatter.directive';
import { ApiNotificationService } from 'src/app/core/services/api-notification.service';
import { UserSessionService } from 'src/app/core/services/authentication/user-session.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { DynamicTableService } from 'src/app/core/services/dynamic-table.service';
import { TranslationModule } from 'src/app/i18n';
import { PageBodyModule } from '../../../../shared/global/page-body/page-body.module';
import { PageHeaderModule } from '../../../../shared/global/page-header/page-header.module';

@Component({
  selector: 'app-all-ip-rules',
  templateUrl: './all-ip-rules.component.html',
  imports: [
    CommonModule,
    TranslationModule,
    PageBodyModule,
    PageHeaderModule,
    JsonFormatterDirective,
  ],
})
export class AllIpRulesComponent {
  //#region Properties

  pageName = PageNames.ipRules;
  fields = 'pages.ipRules.';
  title = 'pages.ipRules.title';
  @Input() model: SetIpRateLimitRuleRequest[] = [];
  protected onDestroy$ = new Subject<void>();

  @Output('closePage') output_closePage = new EventEmitter<boolean>();

  //#endregion

  constructor(
    protected currentService: ApiTokenService,
    public dialogService: DialogService,
    public apiNotificationService: ApiNotificationService,
    public dynamicTableService: DynamicTableService,
    protected userSession: UserSessionService,
    protected enumService: EnumsService,
    public dynamicTabService: DynamicTabService
  ) {}

  //#endregion
  unSubs() {
    this.onDestroy$.next();
  }

  onClose() {
    this.unSubs();
    this.output_closePage.emit(false);
  }
}
